import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import OwlCarousel from "react-owl-carousel";
import en7p from "../assets/images/products/en-7p/img4.webp";
import io400u from "../assets/images/products/io-400/img3.webp";
import sms230tl from "../assets/images/products/sm-S230/img5.webp";
import xblue from "../assets/images/products/x-blue/img2.webp";
import io60u from "../assets/images/products/io-600u/io600u.png";
import sm2f97 from "../assets/images/products/sm-2f97/sm-2f97.png";
import { Link } from 'react-router-dom';

const options = {
    margin: 30,
    responsiveClass: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 5000,
    navText: ["<", ">"],
    smartSpeed: 1400,
    loop: true,
    responsive: {
        0: {
            items: 1,
        },
        400: {
            items: 2,
        },
        600: {
            items: 2,
        },
        700: {
            items: 3,
        },
        1000: {
            items: 4,
        },
    },
};

const products = [
    {
        id: 'p1',
        title: 'X-BLUE – Alkaline',
        tag: 'Water Machine',
        link: '/products/ionia-x-blue-alkaline-water-machine',
        img: xblue,
    },
    {
        id: 'p2',
        title: 'EN-7P – Alkaline',
        tag: 'Water Machine',
        link: '/products/ionia-en-7p-alkaline-water-machine',
        img: en7p
    },
    {
        id: 'p3',
        title: 'IO-400U – Alkaline',
        tag: 'Water Machine',
        link: '/products/ionia-iq-400u-alkaline-water-machine',
        img: io400u
    },
    {
        id: 'p4',
        title: 'SM-S230TL – Alkaline',
        tag: 'Water Machine',
        link: '/products/ionia-sm-s230tl-alkaline-water-machine',
        img: sms230tl
    },
    {
        id: 'p5',
        title: 'IO-600U FAUCET',
        tag: 'Under Sink',
        link: null,
        img: io60u
    },
    {
        id: 'p6',
        title: 'SM-2F97” TFT',
        tag: 'LCD LUXURY',
        link: null,
        img: sm2f97
    },
]

function RecommendedProducts() {
    return (
        <section className='recommended_products'>
            <Container>
                <Row>
                    <Col md={12}>
                        <div className="title__wrap regular">
                            <h2 className="primary-color mb-4">Related Products</h2>
                        </div>
                        <OwlCarousel
                            className="slider-items owl-carousel"
                            {...options}
                        >
                            {products.map((item, index) => {
                                return <div className='item'>
                                    <Link to={item.link}>
                                        <div className='border p-3 rounded-2 h-100'>
                                            <img src={item.img} className='thumb' />
                                            <h5>{item.title}</h5>
                                            <p className='text-blue m-0'>{item.tag}</p>
                                        </div>
                                    </Link>
                                </div>
                            })}
                        </OwlCarousel>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default RecommendedProducts